import { Typography } from '@mui/material'
import { Box, Stack } from '@mui/system'
import React from 'react'

import { brightTurquoise, darkBlue } from '@/refactor/colors'
import styled, { FontFamily } from '@/styles'

export const ButtonsContainer = styled(Stack)`
	${(p) => p.theme.breakpoints.up('sm')} {
		flex-direction: row;
		justify-content: center;
	}
`

export interface UnavailablePageInfoProps {
	buttons?: React.ReactNode
	title: React.ReactNode
	subtitle: React.ReactNode
	className?: string
	buttonsContainerSx?: React.ComponentProps<typeof ButtonsContainer>['sx']
	titleSx?: React.ComponentProps<typeof Typography>['sx']
	subtitleSx?: React.ComponentProps<typeof Typography>['sx']
	contentSx?: React.ComponentProps<typeof Box>['sx']
}

export function UnavailablePageInfo({
	children,
	title,
	subtitle,
	buttons,
	className,
	titleSx,
	subtitleSx,
	buttonsContainerSx,
	contentSx,
}: React.PropsWithChildren<UnavailablePageInfoProps>) {
	return (
		<Box component="div" textAlign="center" padding={4} className={className} sx={contentSx}>
			<Stack gap={3} textAlign="center">
				<Typography
					sx={{
						fontFamily: FontFamily.Comfortaa,
						color: brightTurquoise,
						fontWeight: 'bold',
						fontSize: 20,
						lg: { fontSize: 32 },
						...titleSx,
					}}
				>
					{title}
				</Typography>
				<Typography
					sx={{
						color: darkBlue,
						fontSize: 14,
						lg: { fontSize: 18 },
						fontFamily: FontFamily.Comfortaa,
						...subtitleSx,
					}}
				>
					{subtitle}
				</Typography>
				{children}
			</Stack>

			<ButtonsContainer
				sx={{
					mt: 4,
					gap: 2,
					lg: { mt: 10, gap: 4 },
					...buttonsContainerSx,
				}}
			>
				{buttons}
			</ButtonsContainer>
		</Box>
	)
}
